import { Injectable, computed, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
	static readonly ResultsRoute = '/global-search';

	private readonly _query = signal<string>('');
	private readonly _onResultsRoute = signal<boolean>(false);

	readonly query = this._query.asReadonly();
	/** Drives the active highlight on the search entry (set from the router). */
	readonly onResultsRoute = this._onResultsRoute.asReadonly();

	readonly hasQuery = computed(() => this._query().trim().length > 0);

	/** Fires each time when user submits from the sidebar search — even if the
	 *  term is unchanged. The results list subscribes to (re)apply it to its own box. */
	private readonly _submitted = new Subject<string>();
	readonly submitted$ = this._submitted.asObservable();

	setQuery(value: string): void {
		this._query.set(value ?? '');
	}

	setOnResultsRoute(value: boolean): void {
		this._onResultsRoute.set(value);
	}

	submit(): string | null {
		const term = this._query().trim();
		if (!term) return null;
		this._submitted.next(term);
		return term;
	}

	clearInput(): void {
		this._query.set('');
	}

	clear(): void {
		this._query.set('');
	}
}
